(function () {
  function setLoading(checkbox, isLoading) {
    checkbox.disabled = isLoading;
  }

  function notifyCartUpdate(variantId, response) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-addon-toggle',
        productVariantId: variantId,
        cartData: response,
      });
    }
  }

  function addAddon(checkbox, variantId) {
    setLoading(checkbox, true);
    fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          checkbox.checked = false;
        } else {
          notifyCartUpdate(variantId, response);
        }
      })
      .catch(() => {
        checkbox.checked = false;
      })
      .finally(() => setLoading(checkbox, false));
  }

  function removeAddon(checkbox, variantId) {
    setLoading(checkbox, true);
    fetch(window.routes ? window.routes.cart_change_url : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 0 }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          checkbox.checked = true;
        } else {
          notifyCartUpdate(variantId, response);
        }
      })
      .catch(() => {
        checkbox.checked = true;
      })
      .finally(() => setLoading(checkbox, false));
  }

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('.cart-addon__checkbox');
    if (!checkbox) return;

    const variantId = checkbox.dataset.variantId;
    if (!variantId) return;

    if (checkbox.checked) {
      addAddon(checkbox, variantId);
    } else {
      removeAddon(checkbox, variantId);
    }
  });
})();
